import { PaymentMethodId } from '@bigcommerce/checkout/payment-integration-api';

export default PaymentMethodId;
